module.exports = __webpack_public_path__ + "static/media/yellowDartThrown.d4254489.svg";